import { GetPermissionsListResponseItem2 } from 'src/api/requests'

export const groupByModuleAndDomain = (
  permissions?: GetPermissionsListResponseItem2[]
) => {
  const grouped: Record<
    string,
    Record<string, GetPermissionsListResponseItem2[]>
  > = {}

  permissions?.forEach((perm) => {
    const module = perm?.module ?? 'Uncategorized'
    const domain = perm?.domain ?? 'General'

    if (!grouped[module]) {
      grouped[module] = {}
    }

    if (!grouped[module][domain]) {
      grouped[module][domain] = []
    }

    grouped[module][domain].push(perm)
  })

  return grouped
}
